App.controller('ZochInsuranceNotificationCtrl', ['$scope', '$sce', '$state', '$http', 'Config', '$mdDialog', 'zochaInsuranceService', '$timeout', '$stateParams', 'Blob', 'FileSaver', 'insuranceService', function ($scope, $sce, $state, $http, Config, $mdDialog, zochaInsuranceService, $timeout, $stateParams, Blob, FileSaver, insuranceService) {
    $scope.stateParams = $stateParams;

    $scope.page = 'zoch_insurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Zgłoszenie';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.zoch.insurance.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.home.zoch.insurance.list');
    }

    $scope.type = 'UNABLE_TO_DEDUCT';

    $scope.send = function(id) {
        var vm = this;

        if (!vm.form.$valid) {
            return 0;
        }

        var criteria = {
            id: id,
            data: {
                reason: $scope.reason,
                type: $scope.type
            }
        }

        zochaInsuranceService.notify(criteria).then(function (data) {
            if (data.status === 200) {
                $scope.showPopUp('', 'Wiadomość wysłana', 'Zgłoszenie przesłane poprawnie.', 'Przejdź do listy deklaracji', 'root.home.zoch.insurance.list({"user": null})', 'false');

                $scope.type = 'UNABLE_TO_DEDUCT';
                $scope.reason = '';

                vm.form.$setPristine();
                vm.form.$setUntouched();
                vm.form.$submitted = false;
                // $state.go('root.home.zoch.insurance.list');
            }
        });
    }

    $scope.showPopUp = function(ev, head, content, text, target, exit) {
        $mdDialog.show({
            controller: PopUpInfoCtrl,
            templateUrl: Config.TEMPLATES_DIR + 'PopUp/info-big.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                exit: exit,
                head: head,
                content: content,
                button: {
                    text: text,
                    target: target
                }
            }
        }).then(function(data) {

        }, function() {

        });
    }

    function PopUpInfoCtrl($scope, $mdDialog, locals) {
        $scope.locals = locals;

        $scope.hide = function() {
            $mdDialog.hide();
        };

        $scope.cancel = function() {
            $mdDialog.cancel();
        };

        $scope.confirm = function() {
            $mdDialog.hide($scope.locals);
        };
    }
}]);
